<div class="zag-card-title">
  <ng-content></ng-content>
</div>
